import { useEffect } from "react";
import { BrowserRouter, Route, Switch } from "react-router-dom";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { ReactQueryDevtools } from "@tanstack/react-query-devtools";
import { v4 as uuid } from "uuid";
import { RouteLayout } from "./Components";
import LoginCallback from "./Pages/LoginCallback";
import {
  PANEL_KEY_HOSTNAME,
  PanelKeyHostname,
} from "./Pages/ServicePanel/utils/constants";
import { getFromLocalStorage } from "./utils/getFromLocalStorage";
import { routeList } from "./routes/list";
import AuthProvider from "./contexts/auth";
import OrgaoProvider from "./contexts/orgao";

function App() {
  const queryClient = new QueryClient({
    defaultOptions: {
      queries: {
        staleTime: 60 * 1000,
        refetchOnWindowFocus: false,
      },
    },
  });

  useEffect(() => {
    const data = getFromLocalStorage<PanelKeyHostname>(PANEL_KEY_HOSTNAME);
    if (!data) {
      localStorage.setItem(
        PANEL_KEY_HOSTNAME,
        JSON.stringify({ hostname: uuid() })
      );
    }
  }, []);

  return (
    <QueryClientProvider client={queryClient}>
      <AuthProvider>
        <OrgaoProvider>
          <BrowserRouter>
            <Switch>
              <Route path="/login/callback/" component={LoginCallback} />

              {routeList.map((route, index) => (
                <RouteLayout
                  key={`route-${index}`}
                  {...route}
                />
              ))}
            </Switch>
          </BrowserRouter>
        </OrgaoProvider>
      </AuthProvider>
      <ReactQueryDevtools initialIsOpen={false} position="bottom-right" />
    </QueryClientProvider>
  );
}

export default App;
